import React from "react";
import {
  AlertDialog, AlertDialogContent, AlertDialogHeader, AlertDialogTitle, AlertDialogDescription,
  AlertDialogFooter, AlertDialogCancel, AlertDialogAction,
} from "@/components/ui/alert-dialog";
import { AlertTriangle, Loader2 } from "lucide-react";

// Super-Admin force-delete warning. `effects` = list of strings describing what will be reversed.
export const ForceDeleteDialog = ({ open, onOpenChange, title, subject, effects = [], onConfirm, busy = false, testid = "force-delete", verb = "permanently delete", actionNoun = "force-delete", confirmLabel = "Confirm Deletion", busyLabel = "Deleting…" }) => (
  <AlertDialog open={open} onOpenChange={(o) => !busy && onOpenChange(o)}>
    <AlertDialogContent className="bg-white max-w-lg" data-testid={`${testid}-dialog`}>
      <AlertDialogHeader>
        <AlertDialogTitle className="font-[Outfit] flex items-center gap-2 text-red-700">
          <AlertTriangle className="w-5 h-5" /> {title}
        </AlertDialogTitle>
        <AlertDialogDescription asChild>
          <div className="space-y-3 text-sm text-[#2C1810]">
            <div>You are about to {verb} <span className="font-semibold">{subject}</span>. This Super-Admin {actionNoun} will also:</div>
            <ul className="space-y-1.5 rounded-md border border-red-200 bg-red-50 p-3" data-testid={`${testid}-effects`}>
              {effects.filter(Boolean).map((e, i) => (
                <li key={i} className="flex gap-2"><span className="text-red-600">•</span><span>{e}</span></li>
              ))}
              {effects.filter(Boolean).length === 0 && <li className="text-[#8B7355]">No payments or stock to reverse — only the record and its ledger entry will be removed.</li>}
            </ul>
            <div className="text-xs text-[#8B7355]">Every reversal is posted as a mirrored ledger entry and recorded in the Deletions Audit Log. This cannot be undone.</div>
          </div>
        </AlertDialogDescription>
      </AlertDialogHeader>
      <AlertDialogFooter>
        <AlertDialogCancel disabled={busy} data-testid={`${testid}-cancel-btn`}>Cancel</AlertDialogCancel>
        <AlertDialogAction
          onClick={(e) => { e.preventDefault(); onConfirm(); }}
          disabled={busy}
          className="bg-red-600 hover:bg-red-700 text-white"
          data-testid={`${testid}-confirm-btn`}
        >
          {busy ? <><Loader2 className="w-4 h-4 mr-1.5 animate-spin" /> {busyLabel}</> : confirmLabel}
        </AlertDialogAction>
      </AlertDialogFooter>
    </AlertDialogContent>
  </AlertDialog>
);
